import { Injectable } from '@angular/core';
import { TranslateService, Translation } from '@ngx-translate/core';
import { LocaleNumberPipe } from '@app/shared/pipes/locale-number/locale-number.pipe';
import { localizationKeyCheck } from '@app/core/i18n/methods/localization-key-check';
import { ILocalizationKey } from '@app/core/interfaces/localization';

@Injectable({ providedIn: 'root' })
export abstract class FloatingPopupBaseChartService {
  abstract translate: TranslateService;
  abstract localeNumber: LocaleNumberPipe;

  public formatChartNumber(value: number | null | undefined, minFractionDigits = 0, maxFractionDigits = 2): string {
    if (value === null || value === undefined) {
      return '';
    }
    const result = this.localeNumber.transform(value, minFractionDigits, maxFractionDigits);
    return result;
  }

  public chartElementTranslation(value: ILocalizationKey | string): Translation | string {
    return localizationKeyCheck(value) ? this.translate.instant(value) : value;
  }
}
